import mediumZoom from 'medium-zoom';

import '/src/scripts/_global';

import '/src/components/next/globals/navbar/navbar';
import '/src/components/next/blocks/sidenav/sidenav';
import '/src/components/next/blocks/socials/socials';
import '/src/components/next/blocks/feedback/feedback';
import '/src/components/next/blocks/contactus/contactus';

mediumZoom('.article .figure__src');
